import { Box, styled } from '@mui/material';
import { ConstructionIcon } from 'lucide-react';
import { type JSX } from 'react';
import {
  buildMaintenanceModalCopy,
  MAINTENANCE_ACKNOWLEDGE_LABEL,
  MAINTENANCE_MODAL_TITLE,
} from '@/constants/Maintenance/maintenance';
import { corePalette } from '@/themes/colours';
import { formatMaintenanceTime } from '@/utils/functions/maintenance';
import CustomModal from '../Common/CustomModal';
import CustomTypography from '../Common/Typography';
import MaintenanceCopy from './MaintenanceCopy';

const IconChip = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  padding: '4px',
  borderRadius: '8px',
  backgroundColor: corePalette.orange10,
  color: corePalette.orange200,
});

const NARROW_MODAL_SX = {
  '& .MuiPaper-root, & .CustomDialog-ScrollableSection': {
    minWidth: 'unset !important',
    width: 'min(580px, calc(100vw - 48px)) !important',
    maxWidth: 'min(580px, calc(100vw - 48px)) !important',
  },
  // Tightens the body against the header the way the notice is designed.
  '& .simplebar-content > .MuiBox-root': {
    padding: '0px 24px 16px 24px',
  },
};

interface IProps {
  open: boolean;
  startsAt: string;
  expectedEndAt: string;
  onDismiss: () => void;
}

export default function MaintenanceModal({
  open,
  startsAt,
  expectedEndAt,
  onDismiss,
}: IProps): JSX.Element {
  return (
    <CustomModal
      open={open}
      disableBackdropClose
      onClose={onDismiss}
      onConfirm={onDismiss}
      showActions={{ cancel: false, confirm: true }}
      buttonText={{ confirm: MAINTENANCE_ACKNOWLEDGE_LABEL }}
      title={(
        <Box display="flex" flexDirection="row" alignItems="center" gap="8px">
          <IconChip>
            <ConstructionIcon size={24} />
          </IconChip>
          <CustomTypography variant="titleRegular" fontWeight="medium">
            {MAINTENANCE_MODAL_TITLE}
          </CustomTypography>
        </Box>
      )}
      content={(
        <CustomTypography variant="bodyRegular">
          <MaintenanceCopy
            segments={buildMaintenanceModalCopy({
              start: formatMaintenanceTime(startsAt),
              end: formatMaintenanceTime(expectedEndAt),
            })}
          />
        </CustomTypography>
      )}
      sx={NARROW_MODAL_SX}
    />
  );
}
